import { useLayoutEffect, useRef } from 'react';

/** Reveal the current link without moving the page's vertical scroll position. */
export function useActiveNavigationScroll(routeKey: string) {
  const ref = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const nav = ref.current;
    if (!nav) return;
    const reveal = () => {
      const active = nav.querySelector<HTMLElement>('[aria-current="page"]');
      if (!active || !nav.clientWidth) return;
      const bounds = nav.getBoundingClientRect();
      const link = active.getBoundingClientRect();
      if (link.left < bounds.left + 4 || link.right > bounds.right - 4) {
        nav.scrollLeft += link.left - bounds.left - (nav.clientWidth - link.width) / 2;
      }
    };
    reveal();
    const observer = new ResizeObserver(reveal);
    observer.observe(nav);
    const active = nav.querySelector<HTMLElement>('[aria-current="page"]');
    if (active) observer.observe(active);
    return () => observer.disconnect();
  }, [routeKey]);

  return ref;
}
